/*****************************************************************************
 * REVISION 2.0
 * Fecha: 10/03/2026
 *
 * @description JS para manejo de labels (voseo costarricense)
 * @author lferrer / refactored
 * @version 2.0
 *
 ****************************************************************************/
export const properties = {

  // =====================================================================
  // GENERAL / COMPARTIDO
  // =====================================================================
  general_loading: "Cargando",
  general_attention: "Atención",
  general_document_title: "ADEL SELFSERVICE | WEB",
  general_required_fields: "*Datos obligatorios",
  general_yes: "Sí",
  general_no: "No",
  general_field_required: (field) => `El campo ${field} es obligatorio`,
  general_select_default: (field) => `Seleccioná ${field}`,

  // Botones compartidos
  btn_continue: "Continuar",
  btn_back: "Atrás",
  btn_clean_fields: "Limpiar campos",
  btn_start: "EMPEZAR",
  btn_done: "Listo",
  btn_delete_fields: "Borrar campos",
  btn_keep_fields: "Mantener campos",
  btn_login: "Ingresar",
  btn_sending: "Enviando...",

  // Modal limpiar campos
  modal_clean_title: "¿Querés limpiar todos los campos ingresados?",
  modal_clean_warning: "Esta acción no podrá deshacerse",

  // Campos de ubicación compartidos
  field_province: "Provincia",
  field_canton: "Cantón",
  field_district: "Distrito",
  field_neighborhood: "Barrio",
  field_email: "Correo electrónico",
  field_cellphone: "Celular",

  // =====================================================================
  // HOME LAYOUT
  // =====================================================================
  home_error_no_id: "Debés proporcionar un ID de solicitud.",

  // =====================================================================
  // LOGIN (initial.jsx)
  // =====================================================================
  login_brand: "ADEL",
  login_subtitle: "Autenticación del Sistema",
  login_instruction: "Ingresá tus datos para acceder:",
  login_error_empty: "Por favor, ingresá todos los datos.",
  login_error_no_url_id: "Error: ID de solicitud no encontrado en la URL.",
  login_error_bad_request: "Solicitud no existe o ya fue procesada. o código OTP inválido",
  login_error_invalid_otp: "Cédula o código OTP inválido. Por favor, intentá de nuevo.",
  login_id_label: "Número de identificación",
  login_id_placeholder: "Ej: 102340567",
  login_otp_label: "Código OTP",
  login_otp_placeholder: "######",
  login_submitting: "Validando...",

  // =====================================================================
  // AFFILIATION INITIAL
  // =====================================================================
  affiliation_welcome: "Te damos la bienvenida a tu",
  affiliation_title: "Afiliación en Línea",
  affiliation_requirements_title: "Para completar la solicitud, te pediremos:",
  affiliation_photos_count: "3 fotos de tu comercio",
  affiliation_photos_interior: "interior",
  affiliation_photos_front: "frontal",
  affiliation_photos_inventory: "inventario",
  affiliation_document_label: "Documento de relación:",
  affiliation_document_detail: "Permiso Sanitario de Funcionamiento (Ministerio de Salud) , o la Patente Municipal.",
  affiliation_costs_link: "Ver los costos y comisiones aquí",

  // =====================================================================
  // COSTOS (compartido AffiliationInitial + CostDataForm)
  // =====================================================================
  costs_title: "Costos y Comisiones",
  costs_annual_membership: "Membresía",
  costs_central_bank_commission: "Comisión establecida por el Banco Central:",
  costs_local: "Local",
  costs_international: "Internacional",
  costs_per_transaction: "% (monto por transacción)",
  costs_dataphone_rental: "Alquiler del datáfono mensual",
  costs_dollar_equivalent: "O su equivalente en dólares",
  costs_maintenance: "Mantenimiento mensual",
  costs_maintenance_account: "Mantenimiento de cuenta mensual",

  // =====================================================================
  // STEP NAV (App.js)
  // =====================================================================
  step_personal: "Datos personales",
  step_commerce: "Datos de tu comercio",
  step_files: "Archivos",
  step_costs: "Costo y comisiones",

  // =====================================================================
  // PERSONAL DATA FORM
  // =====================================================================
  personal_title: "Ingresá o modificá tus datos personales:",
  personal_field_type_id: "Tipo de identificación",
  personal_field_name: "Nombre",
  personal_field_first_lastname: "Primer apellido",
  personal_field_second_lastname: "Segundo apellido",
  personal_field_identification: "Identificación",
  personal_field_nationality: "Nacionalidad",
  personal_field_birth_country: "País de nacimiento",
  personal_field_birth_date: "Fecha de nacimiento",
  personal_field_education: "Nivel de escolaridad",
  personal_field_profession: "Seleccioná profesión",
  personal_field_occupation: "Ocupación",
  personal_field_civil_status: "Estado civil",
  personal_field_house_number: "Número de casa",
  personal_field_house_side: "Lado Casa",
  personal_field_color: "Color",
  personal_field_exact_address: "Dirección exacta",
  personal_field_phone_home: "Teléfono de tu casa",
  personal_field_phone_work: "Teléfono de tu trabajo",
  personal_option_left: "Izquierda",
  personal_option_right: "Derecha",

  // =====================================================================
  // COMMERCE DATA FORM
  // =====================================================================
  commerce_title: "Ingresá los datos de tu comercio:",
  commerce_field_name: "Nombre del comercio",
  commerce_field_activity: "Actividad del comercio",
  commerce_field_side: "Lado comercio",
  commerce_field_constitution_date: "Fecha constitución",
  commerce_field_address: "Dirección exacta del comercio",
  commerce_field_color: "¿De qué color es el comercio?",
  commerce_field_signage: "¿El comercio se encuentra rotulado?",
  commerce_field_remodeling: "¿El comercio se encuentra en remodelación?",
  commerce_field_location: "¿En este momento te encontrás en el punto donde deseás recibir el datáfono?",
  commerce_field_receive_name: "Nombre de la persona que recibe el datáfono",
  commerce_field_receive_time: "Horario para recibir el datáfono",
  commerce_field_receive_phone: "Teléfono de la persona que recibe el datáfono",
  commerce_field_confirmation: "¿Requerís confirmación de cita 24 horas antes?",
  commerce_field_cellphone: "Celular del comercio",
  commerce_field_phone: "Teléfono de comercio",
  commerce_field_email_notifications: "Correo para notificaciones",
  commerce_field_email_electronic: "Correo para factura electrónica",
  commerce_field_email_chargeback: "Correo para contracargos",
  commerce_option_no_signage: "No, no está rotulado",
  commerce_option_yes_signage: "Sí, está rotulado",
  commerce_option_no_remodeling: "No, no está en remodelación",
  commerce_option_yes_remodeling: "Sí, está en remodelación",
  commerce_option_no_location: "No",
  commerce_option_yes_location: "Sí, deseo recibirlo acá",
  commerce_btn_location: "Ingresá ubicación geográfica",
  commerce_error_coords: "Debés ingresar la ubicación geográfica en el mapa",
  commerce_error_save: "Ocurrió un error al guardar el formulario",
  commerce_loading: "Cargando datos previos...",
  commerce_map_instruction: "Ubicá en el mapa con el puntero",
  commerce_map_detail: "donde querés recibir el datáfono",
  commerce_map_example: "Te mostramos un ejemplo de cómo se muestra:",
  commerce_coord_x: "Coordenada x",
  commerce_coord_y: "Coordenada y",
  commerce_chargeback_info: "Un contracargo es una devolución de dinero que ocurre cuando alguien reclama un cobro hecho en su tarjeta (de crédito o débito) porque no reconoce la compra, no recibió el producto o servicio, o cree que hubo un error o fraude",

  // =====================================================================
  // FILE DATA FORM
  // =====================================================================
  files_title: "Adjuntá los siguientes archivos de tu comercio:",
  files_format_info: "Formatos permitidos: jpg, jpeg, png y pdf. Cada archivo debe pesar como máximo 10 MB.",
  files_photos_title: "Fotos del comercio",
  files_photos_count: "3 fotos de tu comercio.",
  files_photos_quality: "legibles",
  files_photos_resolution: "buena resolución.",
  files_photos_angles: "distintos ángulos.",
  files_drag_drop: "También podés arrastrar y soltar el archivo o imagen.",
  files_document_title: "Documento de Relación",
  files_document_detail: "Puede ser:",
  files_document_option_health: "Permiso Sanitario de Funcionamiento",
  files_document_option_health_source: "(Ministerio de Salud)",
  files_document_option_patent: "Patente Municipal",
  files_error_missing: "Debés adjuntar todas las fotos y el documento antes de continuar",
  files_error_invalid_format: "Solo se permiten archivos JPG, JPEG, PNG o PDF.",
  files_error_invalid_image_format: "Solo se permiten imágenes JPG, JPEG o PNG.",
  files_error_invalid_document_format: "Solo se permiten archivos PDF.",
  files_error_max_size: "El archivo no puede pesar más de 10 MB.",
  files_loading: "⏳ Cargando archivos, por favor esperá...",
  files_uploading: "📤 Tus archivos aún se están procesando en segundo plano.",
  files_btn_interior: "Foto del interior",
  files_btn_front: "Foto frontal",
  files_btn_inventory: "Foto del inventario",
  files_btn_document: "Documento de Relación",
  files_tooltip: "Declaración formal que presenta el empleador ante la CCSS para demostrar que una persona trabaja para él, indicando detalles como el tipo de trabajo, la fecha de inicio y el salario. Este documento es necesario para afiliar al trabajador al seguro social y garantizarle sus derechos laborales y de salud.",

  // =====================================================================
  // COST DATA FORM
  // =====================================================================
  cost_form_title: "Revisá los siguientes detalles y seleccioná los detalles de cobro:",
  cost_currency_question: "¿En qué moneda querés cobrar?",
  cost_account_question: "¿En qué cuenta deseás recibir los pagos del datáfono?",
  cost_option_colones: "Colones",
  cost_option_dollars: "Dólares",
  cost_option_both: "Ambos",
  cost_error_selection: "No has seleccionado moneda a cobrar o cuenta en la que deseás recibir los pagos.",
  cost_error_selection_extended: "Completá moneda, cuenta, transacciones esperadas y los datos adicionales requeridos para continuar.",
  cost_loading: "Cargando configuración de costos...",
  cost_error_save: "Ocurrió un error al enviar el formulario de costos",
  cost_expected_transactions_title: "Transacciones esperadas",
  cost_expected_amount_usd: "Monto total del depósito en dólares",
  cost_expected_amount_crc: "Monto total del depósito en colones",
  cost_industry_question: "¿Pertenecés a alguna de estas industrias?",
  cost_industry_error: "Debés seleccionar una industria.",
  cost_international_question: "¿Va a recibir transacciones internacionales?",
  cost_btn_open_modal: "Completar datos requeridos",
  cost_modal_title: "Datos adicionales requeridos",
  cost_apnfd_section_title: "Cuentas APNFD",
  cost_apnfd_activity_question: "Actividad de la empresa catalogada como APNFD",
  cost_apnfd_new_account: "Nueva Cuenta APNFD",
  cost_apnfd_no_exclusive: "No posee cuentas de uso exclusivo APNFD con el GFBC.",
  cost_apnfd_exclusive_account_label: "Numero Cuenta exclusiva con BAC",
  cost_apnfd_error_activity: "Seleccioná si la actividad de la empresa está catalogada como APNFD.",
  cost_apnfd_error_checks: "Seleccioná al menos una opción de cuentas APNFD.",
  cost_apnfd_error_exclusive_account: "Ingresá el numero de cuenta exclusiva con BAC.",
  cost_ti_section_title: "Transferencias Internacionales",
  cost_ti_recurring_use: "Uso recurrente de transferencias internacionales",
  cost_ti_amount_in: "Monto entrante de Transferencias Mensuales en USD",
  cost_ti_amount_out: "Monto saliente de Transferencias Mensuales en USD",
  cost_ti_reason_label: "Motivo de Uso Recurrente",
  cost_ti_error_recurring: "Debés confirmar el uso recurrente de transferencias internacionales.",
  cost_ti_error_amount_in: "Ingresá el monto entrante mensual en USD.",
  cost_ti_error_amount_out: "Ingresá el monto saliente mensual en USD.",
  cost_ti_error_reason: "Ingresá el motivo de uso recurrente.",

  // =====================================================================
  // CICAC FORM
  // =====================================================================
  cicac_title: "¿Qué es CICAC?",
  cicac_description_1: "Centro de Información Conozca a su Cliente, es una plataforma creada por la",
  cicac_description_sugef: "SUGEF (Superintendencia General de Entidades Financieras)",
  cicac_description_2: "para centralizar y almacenar información de clientes de instituciones financieras. Su objetivo principal es facilitar el cumplimiento de la política",
  cicac_description_kyc: "\"Conozca a su Cliente (KYC)\"",
  cicac_description_3: ", que busca prevenir el lavado de activos y la financiación del terrorismo.",
  cicac_question: "¿Permitís a BAC subir tu información personal al Banco Central de Costa Rica?",
  cicac_reason_title: "Indicá la razón por la cual no autorizás el registro en CICAC:",
  cicac_reason_1: "Por motivos de resguardo y protección de la confidencialidad de información personal.",
  cicac_reason_2: "Las políticas internas de mi representada no me lo permiten.",
  cicac_reason_3: "No veo valor agregado o necesidad de brindar dicha información.",
  cicac_reason_4: "No deseo brindar mi información personal a otras entidades.",
  cicac_reason_5: "No deseo que se filtre mi información o a otras entidades financieras por compartir base de datos.",
  cicac_reason_6: "Prefiero actualizarlo con mi firma digital.",
  cicac_reason_7: "Prefiero ir directamente a cada entidad (si fuese necesario) para brindar mi información.",
  cicac_error_select: "Por favor seleccioná Sí o No.",
  cicac_error_reason: "Debés seleccionar una opción para poder continuar.",
  cicac_error_send: "Error al enviar los datos. Intentá nuevamente.",

  // =====================================================================
  // SIGNATURE FORM
  // =====================================================================
  signature_title: "Para finalizar, firmá en el siguiente cuadro:",
  signature_info: "Asegurate de firmar igual que en tu cédula",
  signature_placeholder: "Firmá acá",
  signature_btn_clear: "Borrar firma",
  signature_confirm: "Confirmo que mi firma es igual que la de mi cédula",
  signature_error_empty: "Por favor, firmá antes de continuar.",

  // =====================================================================
  // SUCCESS FORM
  // =====================================================================
  success_title: "Detalles de tu solicitud",
  success_receiver: "Persona que recibe",
  success_account: "Cuenta para recibir pagos del datáfono*",
  success_currency_both: "Ambos",
  success_currency_label: "Moneda a cobrar con el datáfono",
  success_next_steps: "Siguientes pasos:",
  success_next_steps_detail: "Te llegará un correo para añadir tu firma igual que en tu cédula para finalizar el proceso.",

  // =====================================================================
  // UPLOAD BOX
  // =====================================================================
  upload_added: "Agregada",
  upload_reattach: "Volver a adjuntar",
  upload_error_invalid_format: "El archivo seleccionado no tiene un formato permitido.",
  upload_error_max_size: "El archivo excede el tamaño máximo permitido.",

};
